export const JobPlanServiceConstant = {
    API : 'JobPlan'
}

export const JobPlanAPIServiceConstant = {
    JOBPLANLABOURDETAILSRESPONSE: `${JobPlanServiceConstant.API}/JobPlanLabourDetailsResponse`,
    GETJOBPLANPARTSGRID: `${JobPlanServiceConstant.API}/GetJobPlanPartsGrid`,
    FINDANDREPLACEJOBPLANNUMBER: `${JobPlanServiceConstant.API}/FindAndReplaceJobPlanNumber`,
    GETITEMSEARCH: `${JobPlanServiceConstant.API}/GetItemSearch`,
    GETTASKDETAILS: `${JobPlanServiceConstant.API}/GetTaskDetails`,
    CLEARJOBPLANLABOUR: `${JobPlanServiceConstant.API}/ClearJobPlanLabour`,
    IMPORTJOBPLANBUILDLABOUR: `${JobPlanServiceConstant.API}/ImportJobPlanBuildLabour`,
    IMPORTJOBPLANBUILDPARTS: `${JobPlanServiceConstant.API}/ImportJobPlanBuildParts`,
    SAVEADDTOCR: `${JobPlanServiceConstant.API}/ValidateAndSaveToCr`,
    DELETELABOUR: `${JobPlanServiceConstant.API}/DeleteLabour`,
    DELETEPART: `${JobPlanServiceConstant.API}/DeletePart`,
    JOBPLAN: `${JobPlanServiceConstant.API}/GetJobPlanDetails`,
    GETONCHANGEITEMSEARCH: `${JobPlanServiceConstant.API}/GetItemOnChangeSearch`
}
